export const getAll = (state) => state.messages
